/**
 * Proprietà reattive di formState che NON devono essere lette dal formState
 * congelato passato a FormProvider. Chi ne ha bisogno deve usare
 * `useFormState()` che sottoscrive correttamente via `_subjects`.
 */
const REACTIVE_FORM_STATE_KEYS = new Set([
  'errors',
  'isDirty',
  'isValid',
  'isValidating',
  'isSubmitting',
  'isSubmitted',
  'isSubmitSuccessful',
  'touchedFields',
  'dirtyFields',
  'submitCount',
]);

const warnedKeys = new Set<string>();

/**
 * Dev-only: Proxy che logga un warning (una volta per chiave) se qualcuno
 * legge una proprietà reattiva dal formState congelato.
 */
export function createFrozenFormStateProxy(formState: any): any {
  return new Proxy(formState, {
    get(target, prop, receiver) {
      if (typeof prop === 'string' && REACTIVE_FORM_STATE_KEYS.has(prop)) {
        if (!warnedKeys.has(prop)) {
          warnedKeys.add(prop);
          console.warn(
            `[FormHandler] Lettura di formState.${prop} dal context congelato. ` +
              'Questo valore non si aggiornerà. Usa useFormState() per valori reattivi.',
          );
        }
      }
      return Reflect.get(target, prop, receiver);
    },
  });
}
